import _classCallCheck from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { optionsFromArguments } from "../core/util/Defaults";
import { Multiply } from "../signal/Multiply";
import { ModulationSynth } from "./ModulationSynth";
/**
 * FMSynth is composed of two Tone.Synths where one Tone.Synth modulates
 * the frequency of a second Tone.Synth. A lot of spectral content
 * can be explored using the modulationIndex parameter. Read more about
 * frequency modulation synthesis on Sound On Sound: [Part 1](https://web.archive.org/web/20160403123704/http://www.soundonsound.com/sos/apr00/articles/synthsecrets.htm), [Part 2](https://web.archive.org/web/20160403115835/http://www.soundonsound.com/sos/may00/articles/synth.htm).
 *
 * @example
 * const fmSynth = new Tone.FMSynth().toDestination();
 * fmSynth.triggerAttackRelease("C5", "4n");
 *
 * @category Instrument
 */

export var FMSynth = /*#__PURE__*/function (_ModulationSynth) {
  _inherits(FMSynth, _ModulationSynth);

  var _super = _createSuper(FMSynth);

  function FMSynth() {
    var _this;

    _classCallCheck(this, FMSynth);

    _this = _super.call(this, optionsFromArguments(FMSynth.getDefaults(), arguments));
    _this.name = "FMSynth";
    var options = optionsFromArguments(FMSynth.getDefaults(), arguments);
    _this.modulationIndex = new Multiply({
      context: _this.context,
      value: options.modulationIndex
    }); // control the two voices frequency

    _this.frequency.connect(_this._carrier.frequency);

    _this.frequency.chain(_this.harmonicity, _this._modulator.frequency);

    _this.frequency.chain(_this.modulationIndex, _this._modulationNode);

    _this.detune.fan(_this._carrier.detune, _this._modulator.detune);

    _this._modulator.connect(_this._modulationNode.gain);

    _this._modulationNode.connect(_this._carrier.frequency);

    _this._carrier.connect(_this.output);

    return _this;
  }

  _createClass(FMSynth, [{
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(FMSynth.prototype), "dispose", this).call(this);

      this.modulationIndex.dispose();
      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(ModulationSynth.getDefaults(), {
        modulationIndex: 10
      });
    }
  }]);

  return FMSynth;
}(ModulationSynth);